import React from "react"
import { Container, Row, Col } from "@bootstrap-styled/v4"
import { StaticQuery, graphql } from "gatsby"
import WOW from "react-wow"

import DepoimentosSlider from "./DepoimentosSlider"
import DepoimentosClientes from "./DepoimentosClientes"

import * as S from "./styled"

const Depoimentos = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          topBg: file(relativePath: { eq: "backgrounds/fluid-top-2.png" }) {
            childImageSharp {
              fluid(maxWidth: 1400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          botBg: file(relativePath: { eq: "backgrounds/fluid-bot-3.png" }) {
            childImageSharp {
              fluid(maxWidth: 1400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          dialogHero: file(relativePath: { eq: "trumps/dialog-hero.png" }) {
            childImageSharp {
              fluid(maxWidth: 700) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          content: allMarkdownRemark(
            filter: { fileAbsolutePath: { regex: "/(testimonials)/.*.md$/" } }
            sort: { fields: frontmatter___order, order: ASC }
          ) {
            edges {
              node {
                frontmatter {
                  title
                  description
                  author
                  order
                }
              }
            }
          }
        }
      `}
      render={data => (
        <S.DepoimentosWrapper>
          <S.CurveTop fluid={data.topBg.childImageSharp.fluid} />
          <S.DepoimentosContent>
            <Container>
              <Row>
                <WOW animation="fadeIn">
                  <Col lg={12} className="hero-column">
                    <S.DepoimentosHero
                      fluid={data.dialogHero.childImageSharp.fluid}
                    ></S.DepoimentosHero>
                  </Col>
                </WOW>
                <Col lg={12}>
                  <WOW animation="fadeInUp">
                    <S.DepoimentosHeader>
                      <S.DepoimentosSubTitle>
                        {`Experiência que inspira 🌬️`}
                      </S.DepoimentosSubTitle>
                      <S.DepoimentosTitle>{`Depoimentos`}</S.DepoimentosTitle>
                    </S.DepoimentosHeader>
                  </WOW>
                  <DepoimentosSlider items={data.content.edges} />
                </Col>
              </Row>
            </Container>
          </S.DepoimentosContent>
          <DepoimentosClientes />
          <S.CurveBottom fluid={data.botBg.childImageSharp.fluid} />
        </S.DepoimentosWrapper>
      )}
    />
  )
}

export default Depoimentos
